var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-notification',{staticClass:"kpt-global-notification",attrs:{"type":"is-warning","active":_vm.globalNotificationActive,"aria-close-label":"Close"},on:{"update:active":function($event){_vm.globalNotificationActive=$event}}},[_c('h3',[_vm._v("Global Notification")])])
}
var staticRenderFns = []

export { render, staticRenderFns }